
















































































































































































































import * as memberAPI from '@adobe/edex/frontend/api/member';
import Follow from '@adobe/edex/frontend/components/common/follow.vue';
import { pick } from 'lodash-es';
import { mapActions, mapState } from 'vuex';
import { MetadataType } from '@adobe/edex/ui/shared/frontend/utils/types';
import { isActAsMode, storeActAsInfo } from '@adobe/edex/ui/shared/frontend/utils/actAs';
import { addUrlScheme, isPROD, isSchoolDistrictDialogEnabled } from '@adobe/edex/ui/shared/frontend/utils';
import { stripHTML } from '@adobe/edex/ui/shared/frontend/utils/sanitize';
import '@adobe/edex/ui/shared/components/school-attribution-dialog/school-attribution-dialog';
import { isEmpty } from 'lodash';
import Vue from 'vue';

export enum SocialNetworkID {
  facebook = 'facebook',
  twitter = 'twitter',
  linkedin = 'linkedin',
  behance = 'behance',
  website = 'website',
}

export default {
  props: ['profile'],
  components: { Follow },
  data() {
    return {
      editMode: false,
      loading: false,
      formData: this.getFormData(),
      SocialNetworkID,
      openDialog: false,
      schoolDistrictName: '',
    };
  },
  computed: {
    ...mapState('member', ['member']),
    ...mapState('metadata', ['regions']),
    showActAs() {
      return !isPROD() && !this.canEdit && this.isAdmin && !isActAsMode();
    },
    canEdit() {
      return this.profile.id === this.member?.id;
    },
    isAdmin() {
      return this.member?.isAdmin;
    },
    canSeeProfileCompleteness() {
      return this.canEdit || this.isAdmin;
    },
    isSchoolDistrictAdded() {
      return !isEmpty(this.schoolDistrictName);
    },
    isSchoolDistrictEnabled() {
      return isSchoolDistrictDialogEnabled();
    },
    awards() {
      return this.profile.badgesByCategory['i18n.badge.leadership'] || [];
    },
    reputationLevelLabel() {
      return this.profile.reputationLevel.badge?.i18nLabel;
    },
    reputationLevelBadgeURL() {
      return this.profile.reputationLevel.badge?.imageURL;
    },
    filteredRegions() {
      if (!this.formData?.country || !this.regions) {
        return [];
      }
      return this.regions.filter(({ countryID }) => countryID === this.formData.country.id);
    },
    social() {
      const buildURL = (baseURL, socialNetworkID) => {
        const url = this.profile.socialNetworks.find(({ id }) => id === socialNetworkID)?.url;
        if (!url) {
          return null;
        }
        if (url.startsWith(baseURL)) {
          return url;
        }
        if (baseURL) {
          return `${baseURL}${url}`;
        } else {
          return addUrlScheme(url);
        }
      };
      return [
        {
          id: SocialNetworkID.facebook,
          icon: 'icon-facebook2',
          placeholder: 'Facebook username',
          url: buildURL('https://facebook.com/', SocialNetworkID.facebook),
        },
        {
          id: SocialNetworkID.twitter,
          icon: 'icon-twitter',
          placeholder: 'Twitter username',
          url: buildURL('https://twitter.com/', SocialNetworkID.twitter),
        },
        {
          id: SocialNetworkID.linkedin,
          icon: 'icon-linkedin',
          placeholder: 'LinkedIn username',
          url: buildURL('https://www.linkedin.com/in/', SocialNetworkID.linkedin),
        },
        {
          id: SocialNetworkID.behance,
          icon: 'icon-behance2',
          placeholder: 'Behance username',
          url: buildURL('https://www.behance.net/', SocialNetworkID.behance),
        },
        {
          id: SocialNetworkID.website,
          icon: 'icon-earth',
          placeholder: 'Website',
          url: buildURL(null, SocialNetworkID.website),
        },
      ];
    },
  },
  methods: {
    ...mapActions('metadata', ['fetchByType']),
    handleActAs() {
      if (!confirm('Are you sure?')) {
        return;
      }
      storeActAsInfo({
        originalMember: pick(this.member, 'id', 'firstName', 'lastName'),
        targetMember: pick(this.profile, 'id', 'firstName', 'lastName'),
      });
      window.location.reload();
    },
    getFormData() {
      return {
        ...this.profile,
        ...this.getSocialFormData(),
        regionID: this.profile.region?.id,
      };
    },
    getSocialFormData() {
      const { socialNetworks } = this.profile;
      return Object.values(SocialNetworkID).reduce(
        (acc, socialNetworkID) => ({
          ...acc,
          [socialNetworkID]: socialNetworks.find(({ id }) => id === socialNetworkID)?.url,
        }),
        {}
      );
    },
    onEdit() {
      this.fetchByType(MetadataType.regions);
      this.formData = this.getFormData();
      this.editMode = true;
    },
    openSchoolDistrict() {
      this.openDialog = true;
    },
    closeSchoolDistrict() {
      this.openDialog = false;
    },
    updateSchoolDistrict(event) {
      this.schoolDistrictName = event.detail.schoolDistrict;
    },
    getSchoolDistrict() {
      return this.profile?.schoolDistrict?.districtName;
    },
    raiseErrorToast(event) {
      Vue.toasted.error(Vue.prototype.$t(event.detail.msg));
    },
    onCancel() {
      this.formData = null;
      this.editMode = false;
    },
    async onUpdate() {
      this.loading = true;
      const { jobTitle, biography, city, regionID } = this.formData;
      const socialNetworks = Object.values(SocialNetworkID)
        .filter((socialNetworkID) => this.formData[socialNetworkID])
        .map((socialNetworkID) => ({
          id: socialNetworkID,
          url: stripHTML(this.formData[socialNetworkID]),
        }));
      const { status, data } = await memberAPI.updateSelf({
        jobTitle: stripHTML(jobTitle),
        biography: stripHTML(biography),
        city: stripHTML(city),
        regionID: stripHTML(regionID),
        socialNetworks,
      });
      if (status === 200) {
        this.$emit('updated', data);
      }
      this.loading = false;
      this.formData = null;
      this.editMode = false;
    },
  },
  mounted() {
    this.schoolDistrictName = this.getSchoolDistrict();
  },
};
